import {SxProps} from "@mui/material";

export const header: SxProps = {

};

export const headerContainer: SxProps = {
    padding: '20px 0px',
    width: '662px',
    margin: '0px auto',
    '@media screen and (max-width: 662px)': {
        width: '90%',
    },
}